
function DispatcherRequired() {
    return (
        <div className="App">
            <h1> YOu must be a dispatcher to use the command portal</h1>
        </div>
    );
}

export default DispatcherRequired;